import * as React from "react";
import "./ProgressBar.scss";

interface IProgressBarProps {
  min: number;
  max: number;
  value: number;
  labelMin?: string;
  labelMax?: string;
}

export class ProgressBar extends React.Component<IProgressBarProps> {
  public render() {
    const progress = Math.round((this.props.value / this.props.max) * 100) / 100;

    return (
      <div className={"ProgressBar"}>
        {this.props.labelMin && <div className="BrogressBar__minLabel">{this.props.labelMin}</div>}
        <div className={"ProgressBar__bar"}>
          <div className={"ProgressBar__bar__progress"} style={{transform: `scaleX(${progress})`}} />
        </div>
        {this.props.labelMax && <div className="BrogressBar__minLabel">{this.props.labelMax}</div>}
      </div>
    );
  }
}
